export default [
    { icon: "dashboard", title: "Home", name: "Home" },
    { icon: "dashboard", title: "Yeast Display", name: "Yd" },
    { icon: "dashboard", title: "TCR Engineering", name: "Tcreng" },
    { icon: "dashboard", title: "Plots", name: "Plot" },
    { icon: "dashboard", title: "TCR Order Generation", name: "GeneratingOrder" },
    { icon: "dashboard", title: "TCR Order Processing", name: "ProcessingOrder" },

    // { icon: "dashboard", title: "Login", name: "Login" },
    // { icon: "dashboard", title: "Register", name: "Register" },
    { icon: "dashboard", title: "Login", name: "Authenticator" },

];
